/**
 * Separator component type definitions
 */

export enum SeparatorThickness {
  Thin = 'thin',
  Default = 'default',
  Thick = 'thick',
}

export enum SeparatorSpacing {
  Tight = 'tight',
  Default = 'default',
  Loose = 'loose',
}

export enum SeparatorStyle {
  Solid = 'solid',
  Dashed = 'dashed',
  Dotted = 'dotted',
}
